export class LiquidacaoRetorno {
    codigoProjeto: string;
    anoExercicio: number;
    numeroEmpenho: string;
    codigoCredor: number;
    cnpjCpfCredor: string;
    nomeCredor: string;
    numeroProcessoSEI: string;
    mensagemErro: string;
    reenviada: boolean;
    valor: number;
    numeroObservacao: string;

    constructor () {
    }
}



// WEBPACK FOOTER //
// ./src/app/models/pagamento/liquidacao-retorno.ts